import React from "react";
import VBarChart from "../../../graphs/VBarChart";

interface Props {
  value: { country: string; value: number }[];
}

const DI: React.FC<Props> = ({ value }) => {
  return <div>{value.length > 0 && <VBarChart data={value} id="DI" />}</div>;
};

export default DI;
